import React, { FC } from 'react'

import { Item, getIdentifierEnumFromString } from 'modules/processes/domain'
import { ItemType } from 'modules/processes/hooks/types'
import { itemTaskType } from 'modules/processes/lib/taskTypeConverter'

interface ItemProviderContextProps {
  itemType: ItemType
  setItemType: React.Dispatch<React.SetStateAction<ItemType | undefined>>
}

const ItemProviderContext = React.createContext<ItemProviderContextProps | null>(null)

interface ItemProviderProps {
  item?: Item
  children: React.ReactNode
}
const getinitialItemType = (item?: Item) => {
  if (!item) return

  return itemTaskType(item) || getIdentifierEnumFromString(item?.configurationIdentifier)
}

export const ItemProvider: FC<ItemProviderProps> = ({ item, children }) => {
  const [itemType, setItemType] = React.useState<ItemType | undefined>(
    item && (getinitialItemType(item) as ItemType)
  )

  return (
    <ItemProviderContext.Provider value={{ itemType: itemType!, setItemType }}>
      {children}
    </ItemProviderContext.Provider>
  )
}

export const useItemProvider = (): ItemProviderContextProps => {
  const ItemProviderModule = React.useContext(ItemProviderContext)

  if (!ItemProviderModule)
    throw new Error('useItemProvider must be used within an ItemProviderModule')

  return ItemProviderModule
}
